import { service } from '@ember/service'
import Route from '@ember/routing/route'
import RSVP from 'rsvp'
import type UiScopeRoute from 'district-ui-client/reporting/ui-scope/route'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import { toStatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type { NormalizedInterval } from 'date-fns'

export default class RexBooksReadByLevelRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, period, scopedData } = this.modelFor('reporting.ui-scope') as ModelFor<UiScopeRoute>

    const product: LegacyProductRex = 'rex'
    const statsScope = toStatsScope(uiScope)
    const stats = await this.makeStatsRequest(product, statsScope, period)

    return {
      product,
      uiScope,
      period,
      scopedData,
      ...stats,
    }
  }

  makeStatsRequest = (product: LegacyProductRex, scope: StatsScope, period: NormalizedInterval) => {
    const { studentEvents } = this

    return RSVP.hash({
      booksReadByLevelTotals: studentEvents.booksReadByLevelTotals(product, scope, period),
    })
  }
}
